<!-- 堤防详情 -->
<template>
  <div class="dialog-dike">
    <div class="header">
      <div class="title">{{ data.dfmc || '-' }}</div>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <div class="descriptions-item">
            <span class="key">起点所在地:</span>
            <span class="value">{{ data.qdszd || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">终点所在地:</span>
            <span class="value">{{ data.zdszd || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">起点桩号:</span>
            <span class="value">{{ data.qdzh || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">终点桩号:</span>
            <span class="value">{{ data.zdzh || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">堤防类型:</span>
            <span class="value">{{ data.dflx || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">堤防跨界情况:</span>
            <span class="value">{{ data.dfkjqk || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">河流名称:</span>
            <span class="value">{{ data.hlmc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">河流岸别:</span>
            <span class="value">{{ data.hlab || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">堤防长度:</span>
            <span class="value">{{ data.dfcd || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">管理单位:</span>
            <span class="value">{{ data.gldw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">省级单位:</span>
            <span class="value">{{ data.sjdw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">管理单位性质:</span>
            <span class="value">{{ data.gldwxz || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">管理单位权属:</span>
            <span class="value">{{ data.gldwqs || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">管理单位负责人:</span>
            <span class="value">{{ data.gldwfzr || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">责任人职务:</span>
            <span class="value">{{ data.zrrzw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">联系电话:</span>
            <span class="value">{{ data.lxdh || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">上级主管单位:</span>
            <span class="value">{{ data.sjzgdw || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-dike {
  width: 53.35rem;
  min-width: 53.35rem;
  .header {
    text-align: left;
    margin-bottom: 15px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: right;
          }
        }
      }
    }
  }
}
</style>
